export enum CookieNamesEnum {
  Cart = 'cart',
  Site = 'site',
  AsmSession = 'asmSession',
  SelectedOrgUnit = 'selectedOrgUnit',
}
